// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_hu","advertDetailContactGroup__header":"c-m_hv","advertDetailContactGroup__value":"c-m_hw"};